document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.classList.add('with-hero')
  document.documentElement.classList.add('nav-light')
})
